import DefaultInfoCard from "./DefaultInfoCard";

const CardImage = ({ imageUrl, alt }) => {
	return (
		<div className="w-full h-[300px] overflow-hidden rounded-t-[50px]">
			<img
				src={imageUrl}
				alt={alt}
				className="w-full h-full object-cover object-top block"
				style={{ aspectRatio: "auto 370 / 300" }}
			/>
		</div>
	);
};

const CardFooter = ({ title, content }) => {
	return (
		<div className={`p-4 h-full `}>
			<h3 className="text-left !text-lg text-is2-gray-700">{title}</h3>
			<div className="[&_p]:text-is2-gray-150 [&_p]:text-sm [&_p]:text-left pt-0">{content}</div>
		</div>
	);
};

export const CarouselCardVariant = ({
	imageUrl,
	imageAlt,
	title,
	headerText,
	subtitle,
	content,
	formattedSectionStyles,
}) => {
	return (
		<div
			className={`w-[100vw] md:w-[250px]  [&>article]:rounded-[50px] [&>article]:p-0  [&>article]:flex [&>article]:flex-col [&>article]:gap-1 [&>article]:h-[600px]`}
		>
			<DefaultInfoCard
				imageComponent={<CardImage imageUrl={imageUrl} imageAlt={imageAlt} />}
				content={null}
				footerComponent={<CardFooter title={headerText ?? title} subtitle={subtitle} content={content} />}
				formattedSectionStyles={formattedSectionStyles}
			/>
		</div>
	);
};
